import { render, staticRenderFns } from "./MobBasicCore.vue?vue&type=template&id=42fd155a&scoped=true"
import script from "./MobBasicCore.vue?vue&type=script&setup=true&lang=js"
export * from "./MobBasicCore.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd155a",
  null
  
)

export default component.exports